import { Component, Input, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ApiService, AuthService, CalendarService, ConditionService, DialogService, FieldService, FormulaService, MetadataService, ModalService, SessionService, TranslatorService } from '../../../services';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { DialogComponent } from '../../common/dialog/dialog.component';
import { UscDialogComponent } from '../usc-dialog/usc-dialog.component';

@Component({
    selector: 'sn-usc-action-plan-table',
    templateUrl: './usc-action-plan-table.component.html',
    styleUrls: ['./usc-action-plan-table.component.css']
})
export class UscActionPlanTableComponent implements OnInit {
    @Input() view: string;
    @Input() item_ID: number;

    is_action_plan_loaded: boolean = false;
    is_saving_todays_goal: boolean = false;
    is_draft_mode_or_next_month: boolean = true;
    is_draft_mode: boolean = false;
    is_not_draft_mode: boolean = false;
    is_not_draft_mode_and_not_next_month: boolean = false;
    is_requested: boolean = false;
    is_approved: boolean = false;
    is_approved_edit_mode: boolean = false;
	is_owner: boolean = true;
    is_approver: boolean = false;
    is_quota_change_msg_shown: boolean = false;
    is_this_month_action_plan: boolean = false;
    is_next_month_action_plan: boolean = false;
    is_prev_month_action_plan: boolean = false;
	is_store_action_plan: boolean = false;
	is_assistant_action_plan: boolean = false;
    is_missing_quota: boolean = false;
    days_remaining: number = 0;
    full_name: string = "";
    is_retail_corp: boolean = false;
    is_retail_agent: boolean = false;
    current_action_plan: any = null;
    last_saved_action_plan: any = null;
    business_drivers: any[] = [];
    last_saved_business_drivers: any[] = [];
    business_drivers_loaded: boolean = false;
    other_details_list: any = {};
    leader_approvers: any;
    public visibleColumnFields: Array<any> = [];
    private viewConditions: Array<any> = [];
    private viewFormulas: Array<any> = [];
    private viewSettings: any;
    public columnFields: Array<any> = [];
	public plan_month: string = "Jan";
	public plan_year: string = "2022";
	public total_estimated_payout: number = 0;
	public total_pacing_payout: number = 0;
	public payout_estimate: any;
    private quota_changed_list: any[];

    public static error_code_missing_quota: number = -1002;

    constructor(
        public dialogService: DialogService,
        public uscStoreService: UscStoreService,
        public fieldService: FieldService,
        public metaDataService: MetadataService,
        public apiService: ApiService,
        public modalService: ModalService,
        public calendarService: CalendarService,
        public translatorService: TranslatorService,
        public metadataService: MetadataService,
        public conditionService: ConditionService,
        public formulaService: FormulaService,
        public sessionService: SessionService,
        public authService: AuthService,
    ) { }

    ngOnInit() {
        this.is_retail_corp = this.uscStoreService.isUSCellCorp();
        this.is_retail_agent = this.uscStoreService.isUSCellAgent();
        this.is_this_month_action_plan = this.view == this.uscStoreService.view_p2w_this_action_plan;
        this.is_next_month_action_plan = this.view == this.uscStoreService.view_p2w_next_action_plan;
        this.is_prev_month_action_plan = this.view == this.uscStoreService.view_p2w_prev_action_plan;
		var dlg = this.dialogService.showLoadingDlg(DialogComponent, {msg: "Retrieving Action Plan..."});
        if (this.is_prev_month_action_plan) {
            this.loadPreviousActionPlan(dlg);
        } else {
            this.is_approved_edit_mode = !this.uscStoreService.is_this_month_action_plan_required && this.uscStoreService.has_current_month_quota_changed;
            this.loadCurrentActionPlan(dlg);
        }
    }

    loadPreviousActionPlan(dlg: NgbModalRef) {
        var ap = this.uscStoreService.getPreviousUserActionPlanByID(this.item_ID);
        this.setCurrentActionPlan(ap);
        dlg.dismiss();
        this.loadTableViewMetaData();
    }

    loadCurrentActionPlan(dlg: NgbModalRef) {
        var view_action;
        if (this.is_this_month_action_plan) view_action = this.uscStoreService.action_get_this_month_action_plan;
        if (this.is_next_month_action_plan) view_action = this.uscStoreService.action_get_next_month_action_plan;
        if (view_action) {
            // always load this month action plan first to ensure it is submitted
            if (this.item_ID > 0) {
                this.uscStoreService.processActionOnViewItem(this.uscStoreService.view_p2w_action_plan, this.item_ID, view_action, null).subscribe(
                    result => { 
                        this.setCurrentActionPlan(result.data);
                        dlg.dismiss();
                        this.loadTableViewMetaData();
                    }
                );
            } else {
                this.uscStoreService.processActionOnViewItems(this.uscStoreService.view_p2w_action_plan, view_action, null).subscribe(result => {
                    dlg.dismiss();
                    if (result && result.errors) {
                        var missing_quota = result.errors.find(e => e.error_code == UscActionPlanTableComponent.error_code_missing_quota);
                        if (missing_quota != null) this.is_missing_quota = true;
                    } else {
                        this.setCurrentActionPlan(result.data);
                        this.loadTableViewMetaData();
                    }
                })                
            }
        }        
    }

    setCurrentActionPlan(action_plan) {
        if (action_plan) {
            this.current_action_plan = action_plan;
            this.last_saved_action_plan = JSON.parse(JSON.stringify(action_plan));
			this.is_owner = action_plan.ur_user_ID.toString() == this.authService.getActive().ID;
            this.is_store_action_plan = action_plan.ur_title == 'Store';
            this.is_assistant_action_plan = action_plan.ur_title == 'Assistant Manager';
            this.plan_month = this.calendarService.getAbbrMonthName(parseInt(this.current_action_plan.cs_subject.substr(4)) - 1);
            this.plan_year = action_plan.cs_subject.substring(0, 4);
            this.is_draft_mode = action_plan.cs_status == this.uscStoreService.action_plan_status_draft;
            this.is_not_draft_mode = action_plan.cs_status != this.uscStoreService.action_plan_status_draft;
            this.is_not_draft_mode_and_not_next_month = this.is_not_draft_mode && action_plan.cs_subject != this.uscStoreService.getNextMonthActionPlanSubject();
            this.is_requested = action_plan.cs_status == this.uscStoreService.action_plan_status_requested;
            this.is_approved = action_plan.cs_status == this.uscStoreService.action_plan_status_approved;
            this.is_draft_mode_or_next_month = this.is_draft_mode || action_plan.cs_subject == this.uscStoreService.getNextMonthActionPlanSubject();
			this.is_approver = this.is_requested && this.uscStoreService.isLeader();
			if (this.is_store_action_plan) this.is_approver = this.is_requested && this.uscStoreService.isExec();
            this.is_action_plan_loaded = true;

            //{{base_url}}/Salesnow.svc/views/view_usc_p2w_action_plan_table/0/actions/action_usc_get_action_plan_approvers
            this.uscStoreService.processActionOnViewItem(this.uscStoreService.view_p2w_prev_action_plan_table, 0, "action_usc_get_action_plan_approvers", { }).subscribe(result => {
                this.leader_approvers = result.data.approvers;
            })
        }
    }    

    loadTableViewMetaData() {
        this.business_drivers_loaded = false;
        this.visibleColumnFields = [];
        this.columnFields = [];
        var fa_view = this.is_prev_month_action_plan ? this.uscStoreService.view_p2w_prev_action_plan_focus_actions : this.uscStoreService.view_p2w_action_plan_focus_actions;
        this.metadataService.getTableViewMetaData(fa_view, {}, true).subscribe(result => {
            this.other_details_list.focus_actions = {
                columnFields: result.meta_data.column_fields,
                viewConditions: result.meta_data.view_conditions,
                viewFormulas: result.meta_data.view_formulas,
                viewSettings: result.meta_data.view_settings,
            }
        });

        var on_view = this.is_prev_month_action_plan ? this.uscStoreService.view_p2w_prev_action_plan_observation_notes : this.uscStoreService.view_p2w_action_plan_observation_notes;
        this.metadataService.getTableViewMetaData(on_view, {}, true).subscribe(result => {
            this.other_details_list.observation_notes = {
                columnFields: result.meta_data.column_fields,
                viewConditions: result.meta_data.view_conditions,
                viewFormulas: result.meta_data.view_formulas,
                viewSettings: result.meta_data.view_settings,
            }
        });

        if (this.is_retail_agent) {
            var sf_view = this.is_prev_month_action_plan ? this.uscStoreService.view_p2w_prev_action_plan_self_reflection : this.uscStoreService.view_p2w_action_plan_self_reflection;
            this.metadataService.getTableViewMetaData(sf_view, {}, true).subscribe(result => {
                this.other_details_list.self_reflection = {
                    columnFields: result.meta_data.column_fields,
                    viewConditions: result.meta_data.view_conditions,
                    viewFormulas: result.meta_data.view_formulas,
                    viewSettings: result.meta_data.view_settings,
                }
            });
        }

        var lf_view = this.is_prev_month_action_plan ? this.uscStoreService.view_p2w_prev_action_plan_leader_feedback : this.uscStoreService.view_p2w_action_plan_leader_feedback;
        this.metadataService.getTableViewMetaData(lf_view, {}, true).subscribe(result => {
            this.other_details_list.leader_feedback = {
                columnFields: result.meta_data.column_fields,
                viewConditions: result.meta_data.view_conditions,
                viewFormulas: result.meta_data.view_formulas,
                viewSettings: result.meta_data.view_settings,
            }
        });

        var ef_view = this.is_prev_month_action_plan ? this.uscStoreService.view_p2w_prev_action_plan_exec_feedback : this.uscStoreService.view_p2w_action_plan_exec_feedback;
        this.metadataService.getTableViewMetaData(ef_view, {}, true).subscribe(result => {
            this.other_details_list.exec_feedback = {
                columnFields: result.meta_data.column_fields,
                viewConditions: result.meta_data.view_conditions,
                viewFormulas: result.meta_data.view_formulas,
                viewSettings: result.meta_data.view_settings,
            }
        });

        //if (!this.is_store_action_plan && !this.is_assistant_action_plan) {
        if (this.isActionPlanGoalsRequired()) {
            var apt_view = this.is_prev_month_action_plan ? this.uscStoreService.view_p2w_prev_action_plan_table : this.uscStoreService.view_p2w_action_plan_table;
            this.metadataService.getTableViewMetaData(apt_view, {}, true).subscribe(result => {
                this.columnFields = result.meta_data.column_fields;
                this.viewConditions = result.meta_data.view_conditions;
                this.viewFormulas = result.meta_data.view_formulas;
                this.viewSettings = result.meta_data.view_settings;
                this.reloadItems();
            });
        } else {
            this.reloadItems();
        }
    }

    reloadItems(dlg:NgbModalRef = null) {
        this.quota_changed_list = [];
        var params:any = { est: 'ST_Search', id: 0 };
        if (this.item_ID && this.item_ID > 0) params.id = this.item_ID;
        else if (this.is_this_month_action_plan) params.SP_ACTION_PLAN_MONTH = this.uscStoreService.getThisMonthActionPlanSubject();
        else if (this.is_next_month_action_plan) params.SP_ACTION_PLAN_MONTH = this.uscStoreService.getNextMonthActionPlanSubject();

        //if (!this.is_store_action_plan && !this.is_assistant_action_plan) {
        if (this.isActionPlanGoalsRequired()) {
            var apt_view = this.is_prev_month_action_plan ? this.uscStoreService.view_p2w_prev_action_plan_table : this.uscStoreService.view_p2w_action_plan_table;
            this.uscStoreService.getData(apt_view, params).subscribe(
                result => {
                    this.business_drivers = result.items;
                    this.last_saved_business_drivers = JSON.parse(JSON.stringify(result.items));
                    this.processActionPlanTableItems();
                    if (dlg) dlg.dismiss();
                },
                err => {
                    console.log(err);
                }
            );
        }

        var fa_view = this.is_prev_month_action_plan ? this.uscStoreService.view_p2w_prev_action_plan_focus_actions : this.uscStoreService.view_p2w_action_plan_focus_actions;
        this.uscStoreService.getData(fa_view, params).subscribe(
            result => {
                this.other_details_list.focus_actions.items = result.items;
                this.processActionPlanOtherDetails(this.other_details_list.focus_actions);
                if ((this.is_store_action_plan || this.is_assistant_action_plan) && dlg) dlg.dismiss();
            },
            err => {
                console.log(err);
            }
        );        

        var on_view = this.is_prev_month_action_plan ? this.uscStoreService.view_p2w_prev_action_plan_observation_notes : this.uscStoreService.view_p2w_action_plan_observation_notes;
        this.uscStoreService.getData(on_view, params).subscribe(
            result => {
                this.other_details_list.observation_notes.items = result.items;
                this.processActionPlanOtherDetails(this.other_details_list.observation_notes);
            },
            err => {
                console.log(err);
            }
        );        

        if (this.is_retail_agent) {
            var sf_view = this.is_prev_month_action_plan ? this.uscStoreService.view_p2w_prev_action_plan_self_reflection : this.uscStoreService.view_p2w_action_plan_self_reflection;
            this.uscStoreService.getData(sf_view, params).subscribe(
                result => {
                    this.other_details_list.self_reflection.items = result.items;
                    this.processActionPlanOtherDetails(this.other_details_list.self_reflection);
                },
                err => {
                    console.log(err);
                }
            );        
        }

        var lf_view = this.is_prev_month_action_plan ? this.uscStoreService.view_p2w_prev_action_plan_leader_feedback : this.uscStoreService.view_p2w_action_plan_leader_feedback;
        this.uscStoreService.getData(lf_view, params).subscribe(
            result => {
                this.other_details_list.leader_feedback.items = result.items;
                this.processActionPlanOtherDetails(this.other_details_list.leader_feedback);
            },
            err => {
                console.log(err);
            }
        );        

        var ef_view = this.is_prev_month_action_plan ? this.uscStoreService.view_p2w_prev_action_plan_exec_feedback : this.uscStoreService.view_p2w_action_plan_exec_feedback;
        this.uscStoreService.getData(ef_view, params).subscribe(
            result => {
                this.other_details_list.exec_feedback.items = result.items;
                this.processActionPlanOtherDetails(this.other_details_list.exec_feedback);
            },
            err => {
                console.log(err);
            }
        );

        if (!this.is_store_action_plan) this.processPayoutEstimates();
    }

    // calculate total_estimated_payout and total_pacing_payout
    processPayoutEstimates() {        
        if (this.uscStoreService.isUSCellCorp()) {
            this.total_estimated_payout = 0;
            this.total_pacing_payout = 0;

            var month_subject = this.is_this_month_action_plan ? this.uscStoreService.getThisMonthActionPlanSubject() : this.uscStoreService.getNextMonthActionPlanSubject();
            var pe_params = { est: 'ST_Search', "SP_MONTH_SUBJECT": month_subject, 'SP_ACTION_PLAN_ID': this.current_action_plan.cs_ID.toString() }
            this.uscStoreService.getData(this.uscStoreService.view_p2w_payout_estimator_goal_table, pe_params).subscribe(
                result => {
                    result.items.forEach(bd => {
                        this.total_estimated_payout += bd.estimated_payout;
                    })        
                },
                err => {
                    console.log(err);
                }
            );

            if (this.is_this_month_action_plan) {
                this.uscStoreService.getData(this.uscStoreService.view_p2w_payout_estimator_forecast_table, pe_params).subscribe(result => {
                    result.items.forEach(bd => {
                        this.total_pacing_payout += bd.estimated_payout;
                    }) 
                    }, err => {
                        console.log(err);
                    }
                ); 
            }            
        }
    }

    getLocalConditionResult(conditions) {
        var local_conditions:any = { };
        conditions.forEach(c => {
            if (c.dependencies) {
                c.dependencies.conditions.forEach(name => {
                    if (name.indexOf('@{') >= 0) {
                        var local_condition_name = name.replace('@{', '').replace('}', '');
                        local_conditions[local_condition_name] = this[local_condition_name];
                    }
                })
            }
        })
        return local_conditions;
    }

    processActionPlanTableItems() {
        this.business_drivers_loaded = true;
        this.business_drivers.forEach(item => {
            if (this.viewFormulas) {
                var formulas = JSON.parse(JSON.stringify(this.viewFormulas));
                item.viewFormulas = this.formulaService.calculateFormulaValuesByItem(formulas, item);
            }

            if (this.viewConditions) {
                var conditions = JSON.parse(JSON.stringify(this.viewConditions));
                item.viewConditions = this.conditionService.evaluateItemValues(conditions, item.viewFormulas, item, this.getLocalConditionResult(conditions));
            }

            if (item.quota_changed == "Yes") {
                this.quota_changed_list.push({ label: item.label, business_driver: item.business_driver });
            }
        });

        if (this.is_owner && this.uscStoreService.has_current_month_quota_changed && !this.is_quota_change_msg_shown) {
            var modalRef = this.dialogService.showDialog(DialogComponent, this.dialogService.dlg_type_confirmation, {msgList: ["Your monthly quota has changed, please revise your monthly goal then submit your action plan."]});
            modalRef.result.then((result) => { this.is_quota_change_msg_shown = true; }, (reason) => {  })
        }

        // extract all visible columns
        this.visibleColumnFields = [];
        this.columnFields.forEach(cf => {
            if (cf.visible) {
                var bVisible = true;
                if (cf.sn_column_visible && cf.sn_column_visible.indexOf('@{') >= 0) {
                    var local_condition = cf.sn_column_visible.replace('@{', '').replace('}', '');
                    bVisible = this[local_condition];
                } else {
                    var condResult = this.conditionService.getCondition(this.business_drivers[0].viewConditions, cf.sn_column_visible);
                    bVisible = condResult ? condResult.result : true;
                }
                if (bVisible) this.visibleColumnFields.push(cf);
            }
        })
    }

    processActionPlanOtherDetails(other_details) {
        other_details.items_loaded = true;

        if (other_details.viewSettings && other_details.viewSettings.allow_new_table_entries && (this.is_draft_mode || this.is_approved_edit_mode)) {
            other_details.items.push(JSON.parse(other_details.viewSettings.new_table_entry_json))
        }

        other_details.items.forEach(item => {
            if (other_details.viewFormulas) {
                var formulas = JSON.parse(JSON.stringify(other_details.viewFormulas));
                item.viewFormulas = this.formulaService.calculateFormulaValuesByItem(formulas, item);
            }

            if (other_details.viewConditions) {
                var conditions = JSON.parse(JSON.stringify(other_details.viewConditions));
                item.viewConditions = this.conditionService.evaluateItemValues(conditions, item.viewFormulas, item, this.getLocalConditionResult(conditions));
            }
        });

        // extract all visible columns
        other_details.visibleColumnFields = [];
        other_details.columnFields.forEach(cf => {
            if (cf.visible) {
                var bVisible = true;
                if (cf.sn_column_visible && cf.sn_column_visible.indexOf('@{') >= 0) {
                    var local_condition = cf.sn_column_visible.replace('@{', '').replace('}', '');
                    bVisible = this[local_condition];
                } else {
                    var condResult = this.conditionService.getCondition(other_details.items.viewConditions, cf.sn_column_visible);
                    bVisible = condResult ? condResult.result : true;
                }
                if (bVisible) other_details.visibleColumnFields.push(cf);
            }
        })
    }

    // addNewItemEntry(items, columnFields) {
    //     var new_item:any = { }
    //     columnFields.forEach(f => {
    //         new_item[f.key] = f.key == "action_plan_status" ? 1 : ""
    //     })
    //     items.push(new_item);
    // }

    getColumnHeader(field): any {
        if (field) {
            var column_label = field.label;
            return column_label;
        }
        return "";
    }

    getFieldValue(item, field): any {
        if (item && field) {
            var field_value = item[field.key];
            switch (field.key) {
                case "mtd_pacing_to_quota":
                case "mtd_pacing_to_goal":
                    if (field_value != null) field_value = this.translatorService.toPercentage(field_value);
                    break;
            }
            return field_value;
        }
        return "";
    }

    getFieldValueStyle(item, field) {
        var fvc = {};
        if (item && field) {
            var field_value = item[field.key];
            var bd_conditions = item.viewConditions;
            if (field_value == null) {
                if (item.leader_feedback || item.exec_feedback) {

                } else {
                    fvc = { "background-color": "#2f75b5" };
                }
            }
            if (item.viewConditions) {
                var is_quota_changed = item.viewConditions.find(c => c.name == "is_quota_changed");
                if (field.key == "quota" && is_quota_changed && is_quota_changed.result) {
                    fvc = { "background-color": "pink" };
                }
            }
        }
        return fvc;
    }

    isFieldEditable(item, field) {
        if (item && field && field.sn_value_editable) {
            var condition = item.viewConditions.find(c => c.name == field.sn_value_editable);
            if (condition) return condition.result;
        }
        return false;
    }

    isValueVisible(action_plan, field) {
        return true;
    }

    public hasValueTooltip(item, field) {
        return (field && field.sn_value_tooltip && field.sn_value_tooltip.length > 0);
    }

    public getValueTooltip(item, field) {
        var tooltip = "";
        if (this.hasValueTooltip(item, field) && item['tip_' + field.key] == null) {
            item['tip_' + field.key] = this.translatorService.translate(null, item, field.sn_value_tooltip);
        }
        return item['tip_' + field.key];
    }

    public hasHeaderTooltip(field) {
        return (field && field.tooltip && field.tooltip.length > 0) || (field && field.html_tooltip && field.html_tooltip.length > 0)
    }

    public getHeaderHtmlTooltip(field) {
        var tooltip = "";
        if (field && field.html_tooltip && field.html_tooltip.length > 0) tooltip = field.html_tooltip;
        else if (field && field.tooltip && field.tooltip.length > 0) tooltip = field.tooltip;
        return tooltip;
    }

    updateActionPlanTable(item, field) {
        var bUpdateActionPlan = true;
        var saved_driver = this.last_saved_business_drivers.find(dr => dr.business_driver == item.business_driver);
        if (saved_driver) {
            var is_quota_or_goal_changed = saved_driver.p2w_monthly_goals != item.p2w_monthly_goals || saved_driver.quota != item.quota;
            var is_agent_mtd_changed = this.is_retail_agent && saved_driver.mtd_actual != item.mtd_actual;
            if (!is_quota_or_goal_changed && !is_agent_mtd_changed) return;  
        }

        if (item && field && field.sn_value_condition && field.sn_value_condition.length > 0) {
            var formulas = JSON.parse(JSON.stringify(this.viewFormulas));
            item.viewFormulas = this.formulaService.calculateFormulaValuesByItem(formulas, item);
            var conditions = JSON.parse(JSON.stringify(this.viewConditions));
            var cond_results = this.conditionService.evaluateItemValues(conditions, item.viewFormulas, item);
            var condition = cond_results.find(c => c.name == field.sn_value_condition);
            if (condition && condition.result == false) {
                bUpdateActionPlan = false;
                var msgList = ["P2W Monthly Goal must be greater than Quota!"];
                var ngbModalRef = this.modalService.openContent(
                    DialogComponent,
                    { dlgType: this.dialogService.dlg_type_confirmation, dlg_config: { msgList: msgList } },
                    { backdrop: 'static', keyboard: false }
                );
                ngbModalRef.result.then(
                    (result) => { ngbModalRef.dismiss(); },
                    (reason) => { ngbModalRef.dismiss(); }
                );
            }
        }
        if (bUpdateActionPlan) {
            if (saved_driver) {
                saved_driver.p2w_monthly_goals = item.p2w_monthly_goals;
                saved_driver.quota = item.quota;
            }
            this.updateActionPlan();
        } else {
            if (saved_driver) item.p2w_monthly_goals = saved_driver.p2w_monthly_goals;
        }
    }

    onFocusOut(item, field) {
        if (item && field == "cs_days_scheduled") {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + (this.is_this_month_action_plan ? 0 : 1);
            var days_in_month = this.calendarService.getDaysInMonth(year, month);
            // days scheduled is required except for store_action plan
            if (!this.is_store_action_plan && (isNaN(item.cs_days_scheduled) || item.cs_days_scheduled <= 0 || item.cs_days_scheduled > days_in_month)) {
                this.current_action_plan.cs_days_scheduled = this.last_saved_action_plan.cs_days_scheduled;
                var modalRef = this.dialogService.showDialog(DialogComponent, this.dialogService.dlg_type_confirmation, {msgList: ["Invalid Input.  Days scheduled must be greater than 0 and less than the number of days within the month."]});
                modalRef.result.then((result) => { }, (reason) => {  })
			} else {
                this.last_saved_action_plan = JSON.parse(JSON.stringify(this.current_action_plan));
                var data = { "days_scheduled": this.current_action_plan.cs_days_scheduled };
                var dlg = this.dialogService.showLoadingDlg(DialogComponent, {msg: "Updating Action Plan..."});
                this.apiService.processActionOnViewItem(this.view, this.current_action_plan.view_ID, this.uscStoreService.action_update_days_scheduled, data).subscribe(result => {
                    dlg.dismiss();
                    this.sessionService.log("days scheduled updated");
                });
            }	
        } else {
           var bd = this.business_drivers.find(d => d == item);
            if (bd) {
                this.updateActionPlanTable(item, field);
            } else {
                var fa = this.other_details_list.focus_actions.items.find(i => i == item);
                var on = this.other_details_list.observation_notes.items.find(i => i == item);
                if (fa) this.updateOtherDetails(this.other_details_list.focus_actions.items);
                if (on) this.updateOtherDetails(this.other_details_list.observation_notes.items);
                if (this.is_retail_agent) {
                    var sf = this.other_details_list.self_reflection.items.find(i => i == item);
                    if (sf) this.updateOtherDetails(this.other_details_list.self_reflection.items);
                }
            }
        }
    }

    updateActionPlan() {
        var dlg = this.dialogService.showLoadingDlg(DialogComponent, {msg: "Updating Action Plan..."});
        var business_drivers = JSON.parse(JSON.stringify(this.business_drivers));
        business_drivers.forEach(bd => {
            bd.viewConditions = null;
            bd.viewFormulas = null;
        })
        var action = this.uscStoreService.action_update_this_month_action_plan;
        if (this.is_next_month_action_plan) action = this.uscStoreService.action_update_next_month_action_plan;
        this.uscStoreService.processActionOnViewItemOnPost(this.uscStoreService.view_p2w_action_plan_table, this.current_action_plan.view_ID, action, business_drivers, null).subscribe(
            result => {
                this.reloadItems(dlg);
                this.sessionService.log("Action Plan Updated");
            }
        )
    }

    // submitActionPlan() {
    //     this.is_saving_todays_goal = true;
    //     var business_drivers = JSON.parse(JSON.stringify(this.business_drivers));
    //     business_drivers.forEach(bd => {
    //         bd.viewConditions = null;
    //         bd.viewFormulas = null;
    //     })        
    //     var action = this.uscStoreService.action_this_month_action_plan_submission;
    //     if (this.is_next_month_action_plan) action = this.uscStoreService.action_next_month_action_plan_submission;
    //     this.uscStoreService.processActionOnViewItemOnPost(this.uscStoreService.view_p2w_action_plan_table, this.current_action_plan.view_ID, action, business_drivers, null).subscribe(
    //         result => {
    //             this.reloadItems();
    //             this.sessionService.log("Action Plan Submitted");
    //         }
    //     )
    // }

    updateOtherDetails(other_details_items) {
        var items = JSON.parse(JSON.stringify(other_details_items));
        items.forEach(bd => {
            items.viewConditions = null;
            items.viewFormulas = null;
        })
        var dlg = this.dialogService.showLoadingDlg(DialogComponent, {msg: "Updating Action Plan..."});
        var action = this.uscStoreService.action_update_this_month_action_plan;
        if (this.is_next_month_action_plan) action = this.uscStoreService.action_update_next_month_action_plan;
        this.uscStoreService.processActionOnViewItemOnPost(this.uscStoreService.view_p2w_action_plan_table, this.current_action_plan.view_ID, action, items, null).subscribe(
            result => {
                this.reloadItems(dlg);
                this.is_saving_lefn = false;
                this.sessionService.log("Action Plan Updated");
            }
        )
    }

    is_saving_lefn:boolean = false;
    submitLeaderFeedback() {
        this.is_saving_lefn = true;
        this.updateOtherDetails(this.other_details_list.leader_feedback.items);
    }

    submitExecFeedback() {
        this.is_saving_lefn = true;
        this.updateOtherDetails(this.other_details_list.exec_feedback.items);
    }

    isActionPlanDaysScheduledRequired(): boolean {
		return !this.is_store_action_plan && !this.is_assistant_action_plan;
	}

    isActionPlanGoalsRequired(): boolean {
        if (this.uscStoreService.isUSCellAgent()) return true;
		return !this.is_store_action_plan && !this.is_assistant_action_plan;
	}
    
	getActionPlanStatus() {
		if (this.is_requested) return "Awaiting for Approval";
		if (this.is_approved) return "Approved";
        return "Draft";
	}

    getDateValue(value) {
		if (value && value.length > 0) {
			var date = new Date(value);
			return this.calendarService.getDateText(date, "yyyy-MM-dd hh:mm tt");
		}
		return "";
	}

	validateActionPlan() : any[] {
		var errors = [];
		var bValid = true;
		var cs_days_scheduled = parseInt(this.current_action_plan.cs_days_scheduled);
		var date = new Date();
		var year = date.getFullYear();
		var month = date.getMonth() + (this.is_this_month_action_plan ? 0 : 1);
		var days_in_month = this.calendarService.getDaysInMonth(year, month);
        if (this.isDaysScheduledRequired()) {
			// cs_days_scheduled must be with in days_in_month
			if (isNaN(cs_days_scheduled) || cs_days_scheduled <= 0 || cs_days_scheduled > days_in_month) {
				errors.push("- Days scheduled must be greater than 0 and less than the number of days within the month");
				bValid = false;
			}
        }
		if (this.isActionPlanGoalsRequired()) {
			// all p2w goals cannot be empty and must be more than the base quota
            var error = "- _BD_ P2W Monthly Goals cannot be empty and must be more than the base quota";
            this.business_drivers.forEach(bd => {
                if (this.is_retail_agent) {
                    var component_drivers:any[] = [ 'postpaid_basic', 'postpaid_everyday', 'postpaid_even_better', 'upgrades_basic', 'upgrades_everyday', 'upgrades_even_better' ];
                    if (bd.quota > 0 && bd.p2w_monthly_goals - bd.quota <= 0 && component_drivers.indexOf(bd.business_driver) < 0) {
                        errors.push(error.replace('_BD_', bd.label));
                        bValid = false;
                    }
                } else if (bd.p2w_monthly_goals - bd.quota <= 0) {
                    errors.push(error.replace('_BD_', bd.label));
                    bValid = false;
                }
            })            
		}
		// at least one area of focus
		var focus_actions = JSON.parse(JSON.stringify(this.other_details_list.focus_actions.items));
		var empty_index = focus_actions.findIndex(a => a.area_of_focus.trim() == '' && a.sales_plan_actions.trim() == '');
		if (empty_index >= 0) focus_actions.splice(empty_index, 1);
		if (focus_actions.length == 0) {
			errors.push("- Must enter at least one Area of Focus");
			bValid = false;
		} 
		// sales_plan_actions cannot be empty
		var empty_spa_index = focus_actions.findIndex(a => a.area_of_focus.trim() == '' || a.sales_plan_actions.trim() == '');
		if (empty_spa_index >= 0) {
			errors.push("- Area of Focus and Sales Plan Action cannot be empty");
			bValid = false;
		}
		// observation notes cannot be empty
        if (this.is_retail_corp) {
            var obseveration_notes = JSON.parse(JSON.stringify(this.other_details_list.observation_notes.items));
            var empty_notes_index = obseveration_notes.findIndex(a => a.notes.trim() == '');
            if (empty_notes_index >= 0) {
                errors.push("- Observation Notes cannot be empty");
                bValid = false;
            }
        }

        if (this.is_retail_agent) {
            // self reflection cannot be empty
            var self_reflection = JSON.parse(JSON.stringify(this.other_details_list.self_reflection.items));
            var empty_notes_index = self_reflection.findIndex(a => a.notes.trim() == '');
            if (empty_notes_index >= 0) {
                errors.push("- Self Reflection cannot be empty");
                bValid = false;
            }
        }
		return errors;
	}

    isPayoutEstimateRequired() {
        if (this.uscStoreService.isUSCellAgent()) return false;
        return this.isActionPlanGoalsRequired() && this.is_this_month_action_plan;
    }

    isDaysScheduledRequired() {
        return !this.is_prev_month_action_plan && this.isActionPlanGoalsRequired() && !this.is_store_action_plan;
    }

    isActionPlanSubmissionMode() {
        if (this.uscStoreService.isUSCellAgent() && this.is_draft_mode && this.is_store_action_plan && !this.uscStoreService.isExec()) {
            return true;
        }
        return this.is_draft_mode && ( this.is_owner || ! this.isActionPlanGoalsRequired());
    }

	requestForApproval() {
		var errors = this.validateActionPlan();
		if (errors.length > 0) {
			var msgList = [];
			msgList.push("");
			msgList = msgList.concat(errors);
			this.modalService.openContent(
				UscDialogComponent,
				{ dlgType: this.uscStoreService.dialog_type_action_plan_approval_warning, msg_config: { errors: msgList }},
				{ size: "lg", backdrop: 'static', keyboard: false }
			).result.then(
				(result) => { }, (reason) => { }
			);        
		} else {			
			var msgList = [];
			msgList.push("Please select the approver for your action plan?");
			
			var list = [];
			//var leader_approvers = JSON.parse(this.current_action_plan.leader_approvers).approvers;
			this.leader_approvers.forEach(a => {
				if (this.is_store_action_plan) {
					if (a.approver_title == "Mgr Retail Area Sales") list.push({ name: `${a.approver} (${a.approver_title})`, value: a.approver_ID })
					if (a.approver_title == "Dir Retail Sales and Operations") list.push({ name: `${a.approver} (${a.approver_title})`, value: a.approver_ID })
					if (a.approver_title == "Telesales Supervisor") list.push({ name: `${a.approver} (${a.approver_title})`, value: a.approver_ID })
					if (a.approver_title == "Mgr Telesales") list.push({ name: `${a.approver} (${a.approver_title})`, value: a.approver_ID })
					if (a.approver_title == "Area Manager") list.push({ name: `${a.approver} (${a.approver_title})`, value: a.approver_ID })
					if (a.approver_title == "Admin/Manager of Agency") list.push({ name: `${a.approver} (${a.approver_title})`, value: a.approver_ID })
					if (a.approver_title == "Master") list.push({ name: `${a.approver} (${a.approver_title})`, value: a.approver_ID })
                } else {
					list.push({ name: `${a.approver} (${a.approver_title})`, value: a.approver_ID })
				}
			})
			var default_value = list[0].value;
			if (this.authService.getActive().ID == default_value.toString() && list.length > 1) default_value = list[1].value;
			var input = { type: "L", class: 'col-md-12 col-lg-12 text-center sn-i-center', list: list, default_value: default_value };
			
			var buttons = [];
			var btn_confirm = { type: 'confirm', label: 'Submit', class: 'col-md-6 col-lg-6 text-center', event: 'apprver-selected' };
			var btn_cancel = { type: 'cancel', label: 'Cancel', class: 'col-md-6 col-lg-6 text-center', event: 'cancel' };
			buttons.push(btn_confirm);
			buttons.push(btn_cancel);

			this.modalService.openContent(
				DialogComponent,
				{ 
					dlgType: this.dialogService.dlg_type_prompt,
					dlg_config: {
						msgList: msgList,
						input: input,
						buttons: buttons
					}
				},
				{ backdrop: 'static', keyboard: false }
			).result.then(
				(result) => { 
                    var dlg = this.dialogService.showLoadingDlg(DialogComponent, {msg: "Submitting Action Plan..."});
					var params = { approver_ID: result.response.value }
					this.apiService.processActionOnViewItem(this.uscStoreService.view_p2w_action_plan, this.current_action_plan.view_ID, this.uscStoreService.action_action_plan_approval, params).subscribe(
						result => {
							if (this.is_this_month_action_plan) {
                                dlg.dismiss();
                                this.uscStoreService.is_this_month_action_plan_required = false;
                                this.uscStoreService.has_current_month_quota_changed = false;
                                if (this.isActionPlanGoalsRequired()) this.uscStoreService.setCurrentView(this.uscStoreService.view_p2w_todays_goal);
                                else this.uscStoreService.setCurrentView(this.uscStoreService.view_first);
							} else {
                                this.loadCurrentActionPlan(dlg);
							}
						}
					)
				},
				(reason) => { }
			);        
		}
    }

    approveActionPlan() {
		var params = {  }
		this.apiService.processActionOnViewItem(this.uscStoreService.view_p2w_action_plan, this.current_action_plan.view_ID, this.uscStoreService.action_action_plan_approved, params).subscribe(
			result => { 
                // this.reloadItems(); 
                this.is_approved = true;
                this.is_requested = false;
                this.is_approver = false;
            }
		)
	}

	rejectApproval() {
		var params = {  }
		this.apiService.processActionOnViewItem(this.uscStoreService.view_p2w_action_plan, this.current_action_plan.view_ID, this.uscStoreService.action_action_plan_rejected, params).subscribe(
			result => { 
				if (this.view == this.uscStoreService.view_p2w_this_action_plan) this.uscStoreService.setCurrentView(this.uscStoreService.view_p2w_team_this_action_plans);
				if (this.view == this.uscStoreService.view_p2w_next_action_plan) this.uscStoreService.setCurrentView(this.uscStoreService.view_p2w_team_next_action_plans);
			}
		)
	}

    editApprovedActionPlan() {
        this.is_approved_edit_mode = true;
        this.processActionPlanOtherDetails(this.other_details_list.focus_actions);
        this.processActionPlanOtherDetails(this.other_details_list.observation_notes);
        if (this.is_retail_agent) this.processActionPlanOtherDetails(this.other_details_list.self_reflection);
        this.processActionPlanTableItems();
    }

    saveApprovedActionPlan() {
        var errors = this.validateActionPlan();
		if (errors.length > 0) {
			var msgList = [];
			msgList.push("");
			msgList = msgList.concat(errors);
			this.modalService.openContent(
				UscDialogComponent,
				{ dlgType: this.uscStoreService.dialog_type_action_plan_approval_warning, msg_config: { errors: msgList }},
				{ size: "lg", backdrop: 'static', keyboard: false }
			).result.then(
				(result) => { }, (reason) => { }
			);        
		} else {
            this.uscStoreService.has_current_month_quota_changed = false;       
            this.is_approved_edit_mode = false;
            this.processActionPlanOtherDetails(this.other_details_list.focus_actions);
            this.processActionPlanOtherDetails(this.other_details_list.observation_notes);
            if (this.is_retail_agent) this.processActionPlanOtherDetails(this.other_details_list.self_reflection);
            this.processActionPlanTableItems();
            var params = {  }
            var dlg = this.dialogService.showLoadingDlg(DialogComponent, {msg: "Re-submitting Approved Action Plan..."});
            this.apiService.processActionOnViewItem(this.uscStoreService.view_p2w_action_plan, this.current_action_plan.view_ID, this.uscStoreService.action_approved_action_plan_updated, params).subscribe(
                result => { 
                    this.reloadItems(dlg);
                    this.sessionService.log("action_approved_action_plan_updated completed");
                }
            )
        }
    }

    allowRevertToDraft() {
        return !this.is_retail_agent && !this.is_owner && this.is_approved;
    }

    allowEditApprovedActionPlan() {
        // default: corp and telesales
        var bAllow = this.is_approved && this.is_owner && !this.is_approved_edit_mode;
        // override for agent leader editing store action plan
        if (this.is_retail_agent && this.is_store_action_plan) {
            bAllow = this.is_approved && this.uscStoreService.isLeader() && !this.is_approved_edit_mode;
        } 
        return bAllow;
    }

	print() {
		window.print();
	}
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-action-plan-table/usc-action-plan-table.component.ts